import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../styles/Alumni/visitorAlumniProfile.css';
import { BiUserX } from 'react-icons/bi';
import { FaFacebook, FaTwitter, FaGithub, FaLinkedin } from 'react-icons/fa';
import { displaySnackbar } from '../../utilities';
import { BASE_URL } from '../../settings';

export default function UserAlumniProfile() {
    const { state } = useLocation();
    const navigate = useNavigate();

    const [username, setUsername] = useState();
    const [email, setEmail] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [githubLink, setGithubLink] = useState();
    const [linkedInLink, setLinkedInLink] = useState();
    const [facebookLink, setFacebookLink] = useState();
    const [twitterLink, setTwitterLink] = useState();
    const [about, setAbout] = useState();
    const [avatar, setAvatar] = useState();
    const [classYear, setClassYear] = useState();
    const [positionName, setPositionName] = useState();
    const [mobile, setMobile] = useState();
    const [alumniFound, setAlumniFound] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        let path = window.location.pathname?.split('/');
        let id = path[path?.length - 1];

        if (state?.alumni) {
            setAlumniFound(true);

            // 👇️ extract data from passed in alumni data
            setUsername(state?.alumni?.username);
            setEmail(state?.alumni?.email);
            setFirstName(state?.alumni?.firstName);
            setLastName(state?.alumni?.lastName);
            setGithubLink(state?.alumni?.githubLink);
            setLinkedInLink(state?.alumni?.linkedInLink);
            setFacebookLink(state?.alumni?.facebookLink);
            setTwitterLink(state?.alumni?.twitterLink);
            setAbout(state?.alumni?.about);
            setAvatar(state?.alumni?.avatar);
            setClassYear(state?.alumni?.classYear);
            setPositionName(state?.alumni?.positionName);
            setMobile(state?.alumni?.mobile);
        } else {
            // 👇️ fetch alumni by id
            fetch(`/alumni/read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            })
                .then(async (response) => {
                    let data = await response.json();
                    setAlumniFound(true);

                    let fetched_alumni = data?.alumni;

                    setUsername(fetched_alumni?.username);
                    setEmail(fetched_alumni?.email);
                    setFirstName(fetched_alumni?.firstName);
                    setLastName(fetched_alumni?.lastName);
                    setGithubLink(fetched_alumni?.githubLink);
                    setLinkedInLink(fetched_alumni?.linkedInLink);
                    setFacebookLink(fetched_alumni?.facebookLink);
                    setTwitterLink(fetched_alumni?.twitterLink);
                    setAbout(fetched_alumni?.about);
                    setAvatar(fetched_alumni?.avatar);
                    setClassYear(fetched_alumni?.classYear);
                    setPositionName(fetched_alumni?.positionName);
                    setMobile(fetched_alumni?.mobile);
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true);
                        setAlumniFound(false);
                    } else {
                        setAlumniFound(false);
                        displaySnackbar('Could not fetch alumni.', true);
                    }
                });
        }
    });

    return (
        <div className='alumni-profile-container'>
            {alumniFound ? (
                <>
                    <div className='profile-header-container'>
                        <button className='go-back-btn' onClick={() => navigate(-1)}>
                            👈️ Go back
                        </button>

                        <div className='profile-picture-container'>
                            <img
                                src={
                                    avatar
                                        ? `${BASE_URL}/alumni/uploads/get-profile-pic/${avatar}`
                                        : require('../../images/profile-pictures/face1.jpg')
                                }
                                alt='profile-picture'
                            />
                        </div>
                    </div>

                    <div className='profile-content-container'>
                        <div className='profile-content-item about'>
                            <div className='header'>
                                <span>About</span>
                            </div>
                            <div className='text'>
                                {about?.length > 0 ? <span>{about}</span> : <span>...</span>}
                            </div>
                        </div>

                        <div className='profile-content-items'>
                            <div className='profile-content-item'>
                                <div className='header'>
                                    <span>Full name</span>
                                </div>
                                <div className='text'>
                                    {firstName?.length > 0 || lastName?.length > 0 ? (
                                        <span>
                                            {firstName} {lastName}
                                        </span>
                                    ) : (
                                        <span>...</span>
                                    )}
                                </div>
                            </div>

                            <div className='profile-content-item'>
                                <div className='header'>
                                    <span>Username</span>
                                </div>
                                <div className='text'>
                                    {username?.length > 0 ? (
                                        <span>@{username}</span>
                                    ) : (
                                        <span>...</span>
                                    )}
                                </div>
                            </div>

                            <div className='profile-content-item'>
                                <div className='header'>
                                    <span>Email</span>
                                </div>
                                <div className='text'>
                                    {email?.length > 0 ? <span>{email}</span> : <span>...</span>}
                                </div>
                            </div>

                            <div className='profile-content-item'>
                                <div className='header'>
                                    <span>Class of</span>
                                </div>
                                <div className='text'>
                                    {classYear?.length > 0 ? (
                                        <span>{classYear}</span>
                                    ) : (
                                        <span>...</span>
                                    )}
                                </div>
                            </div>

                            <div className='profile-content-item'>
                                <div className='header'>
                                    <span>Current work position</span>
                                </div>
                                <div className='text'>
                                    {positionName?.length > 0 ? (
                                        <span>{positionName}</span>
                                    ) : (
                                        <span>...</span>
                                    )}
                                </div>
                            </div>

                            <div className='profile-content-item'>
                                <div className='header'>
                                    <span>Mobile contact</span>
                                </div>
                                <div className='text'>
                                    {mobile?.length > 0 ? (
                                        <span>(+263) {mobile}</span>
                                    ) : (
                                        <span>...</span>
                                    )}
                                </div>
                            </div>

                            <div className='profile-content-item'>
                                <div className='header'>
                                    <span>Social contacts</span>
                                </div>
                                <div className='social-links'>
                                    {facebookLink?.length > 0 ||
                                    githubLink?.length > 0 ||
                                    twitterLink?.length > 0 ||
                                    linkedInLink?.length > 0 ? (
                                        <>
                                            {facebookLink?.length > 0 && (
                                                <a href={facebookLink}>
                                                    <FaFacebook size={30} color='darkblue' />
                                                </a>
                                            )}
                                            {githubLink?.length > 0 && (
                                                <a href={githubLink}>
                                                    <FaGithub size={30} color='black' />
                                                </a>
                                            )}
                                            {twitterLink?.length > 0 && (
                                                <a href={twitterLink}>
                                                    <FaTwitter size={30} color='skyblue' />
                                                </a>
                                            )}
                                            {linkedInLink?.length > 0 && (
                                                <a href={linkedInLink}>
                                                    <FaLinkedin size={30} color='darkblue' />
                                                </a>
                                            )}
                                        </>
                                    ) : (
                                        <span>...</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className='alumni-not-found-container'>
                    <BiUserX size={100} color='#777' className='alumni-not-found-icon' />
                    <span> alumni profile not found </span>
                </div>
            )}
        </div>
    );
}
